export default __webpack_public_path__ + "static/media/instagram.20c9c4a9.svg";